export const severities = [
  { label: 'Not Sure', value: 'not_sure' },
  { label: 'Intolerance', value: 'intolerance' },
  { label: 'Mild', value: 'mild' },
  { label: 'Moderate', value: 'moderate' },
  { label: 'Severe', value: 'severe' },
]

export const unknownRace = 'Prefer not to answer'
export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
export const CommunicationPreference = {
  Both: 'Text and Email',
  Email: 'Email',
  Text: 'Text',
}
export const commPrefs = [CommunicationPreference.Both, CommunicationPreference.Email, CommunicationPreference.Text]
export const ContactMethod = {
  Email: 'email',
  Phone: 'phone',
}

export const AppointmentTypes = {
  Video: 'video',
  Phone: 'phone',
  Async: 'async',
  Other: 'other',
  AsyncMessaging: 'async_messaging',
}

export const AppointmentScheduleTypes = {
  Scheduled: 'sched',
  Unscheduled: 'unschd',
  Async: 'async',
  AdHoc: 'ad_hoc',
  OnDemand: 'on_demand',
  AsyncMessaging: 'async_messaging',
}

export const SchedTypeLabel = {
  [AppointmentScheduleTypes.Scheduled]: 'Scheduled',
  [AppointmentScheduleTypes.Unscheduled]: 'Unscheduled',
  [AppointmentScheduleTypes.Async]: 'Async',
  [AppointmentScheduleTypes.OnDemand]: 'On-Demand',
  [AppointmentScheduleTypes.AsyncMessaging]: 'Async Messaging',
}

export const states = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'VI',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]

/**
 * Define the build environments from VITE_BUILD_ENV.
 * Do not change the values of these constants as they are used in the build process.
 */
export const BuildEnv = {
  Local: 'local',
  QA: 'qa',
  Staging: 'staging',
  Production: 'prod',
}

export const TodoType = {
  RestartCare: 'RE_ENGAGE_PATIENT',
  InitialAppointment: 'APPOINTMENT_NEW',
  PhotoId: 'PHOTO_ID',
  Insurance: 'RX_INSURANCE',
  ProfileIncomplete: 'PROFILE_INCOMPLETE',
  LabFlow: 'LAB_FLOW',
  Assessment: 'ASSESSMENT',
  GileadApplication: 'GILEAD_APPLICATION',
  ROIRequest: 'ROI_REQUEST',
  HivSelfTest: 'HIV_SELF_TEST',
  PaymentFailure: 'PAYMENT_FAILURE',
  RescheduleAppointment: 'RESCHEDULE_APPOINTMENT',
  Generic: 'GENERIC',
}

export const GenericTodoType = {
  NewDocument: 'NEW_DOCUMENT',
}

// The order of the todos in the home page
export const TodoTypeOrder = {
  // Decimals are used to allow for inserting new todos in between existing ones
  [TodoType.PhotoId]: 2.5,
  [TodoType.ProfileIncomplete]: 3,
}

export const VoiceCallStatus = {
  Initiated: 'initiated',
  Ringing: 'ringing',
  InProgress: 'in-progress',
  Completed: 'completed',
  Failed: 'failed',
  Busy: 'busy',
  NoAnswer: 'no-answer',
}

export const LabStatus = {
  Ordered: 'Ordered',
  NeedsReview: 'Needs Review',
  NurseReviewed: 'Nurse Reviewed',
  NeedsFollowUp: 'Needs Follow-up',
  Ready: 'Ready',
  OrderFailed: 'Order Failed',
  ShipmentPending: 'Shipment Pending',
  Shipped: 'Shipped',
  InTransitionToPatient: 'In Transit to Patient',
  FailedDeliveryToPatient: 'Failed Delivery To Patient',
  DeliveredToPatient: 'Delivered To Patient',
  InTransitToLab: 'In Transit to Lab',
  ReceivedByLab: 'Received by Lab',
  ReturnedToLab: 'Returned to Lab',
  LabProcessing: 'Lab Processing',
  LabRejected: 'Lab Rejected',
  LabIssue: 'Lab Issue',
  Pending: 'Pending',
  Requested: 'Requested',
  Cancelled: 'Cancelled',
  Released: 'Released',
  Unmatched: 'Unmatched',
  Reviewing: 'Reviewing',
}

export const LabTypes = {
  Ash: 'Ash',
  MTL: 'MTL',
  Quest: 'Quest',
  GHMC: 'GMHC',
  Manual: 'Manual',
}

export const TaskStatus = {
  ToDo: 'Todo',
  InProgress: 'In Progress',
  Waiting: 'Waiting',
  Completed: 'Completed',
  Expired: 'Expired',
  NotApplicable: 'Not Applicable',
}

export const taskStatusToLabel = {
  [TaskStatus.ToDo]: 'To Do',
  [TaskStatus.InProgress]: 'In Progress',
  [TaskStatus.Waiting]: 'Waiting',
  [TaskStatus.Completed]: 'Done',
  [TaskStatus.Expired]: 'Expired',
  [TaskStatus.NotApplicable]: 'Not Applicable',
}

export const TaskPriority = {
  High: 'high',
  Medium: 'medium',
  Low: 'low',
}

// Constant for the task kinds that have some specific behavior and require conditional checks
export const TaskKind = {
  PriorAuth: 'Prior Auth',
  GileadCustomerSupport: 'Gilead AA Application CS',
  RoiPDF: 'ROI PDF',
  Appeals: 'Appeals',
  ImmediateAccess: 'Immediate Access',

  // Provider PAR Tasks
  PAR: 'Patient At Risk',
  PEP_PAR: 'PEP Patient At Risk',
  HIV_PAR: 'HIV Patient At Risk',
  GLP1_PAR: 'GLP1 Patient At Risk',

  // Provider Tasks
  GileadProvider: 'Gilead AA Application',
  IncompleteLabs: 'Incomplete Labs',
  RxClarification: 'Rx Clarification',
  PendingQuestOrder: 'Pending Quest Order',
  ABNLFollowUp: 'ABNL Lab Follow Up',
  TestOfCure: 'TOC',
  ProviderReminder: 'Provider Reminder',
  CreateQLinkRequest: 'Create QLink Request',

  // Provider License Tasks
  LicenseExpiration: 'License Expiration',
  CertificationExpiration: 'Certification Expiration',

  // Tasks from Provider to MA
  QLinkLab: 'Qlink Lab',

  // Support tasks
  VM: 'VM',
  Email: 'Email',
  PAF: 'PAF',
}

export const getTaskKindLabel = (task) => {
  if (!task) return
  return [TaskKind.GileadCustomerSupport, TaskKind.PriorAuth, TaskKind.Appeals, TaskKind.ImmediateAccess].includes(task.kind)
    ? [task.kind, task.reason].filter(Boolean).join(' – ')
    : task.kind
}

export const isPARKind = (kind) => [TaskKind.PAR, TaskKind.PEP_PAR, TaskKind.HIV_PAR, TaskKind.GLP1_PAR].includes(kind)
export const isProviderKind = (kind) =>
  [
    TaskKind.GileadProvider,
    TaskKind.IncompleteLabs,
    TaskKind.RxClarification,
    TaskKind.PendingQuestOrder,
    TaskKind.ABNLFollowUp,
    TaskKind.TestOfCure,
    TaskKind.ProviderReminder,
    TaskKind.CreateQLinkRequest,
  ].includes(kind)

export const isLicenseExpirationKind = (kind) => kind === TaskKind.LicenseExpiration

// License constants — mirror app/models/license.rb enums
export const LicenseStatus = {
  Active: 'Active',
  Expired: 'Expired',
  Termed: 'Termed',
}

export const LicenseRenewalStatus = {
  Renewing: 'Renewing license',
  NotRenewing: 'Not renewing license',
  Submitted: 'Renewal was submitted',
  Renewed: 'License was renewed',
}

export const FINAL_LICENSE_RENEWAL_STATUSES = [LicenseRenewalStatus.NotRenewing, LicenseRenewalStatus.Renewed]

export const CertificationRenewalStatus = {
  Renewing: 'Renewing certification',
  NotRenewing: 'Not renewing certification',
  Submitted: 'Renewal was submitted',
  Renewed: 'Certification was renewed',
}

export const FINAL_CERTIFICATION_RENEWAL_STATUSES = [CertificationRenewalStatus.NotRenewing, CertificationRenewalStatus.Renewed]

const FINAL_RENEWAL_STATUSES = [...FINAL_LICENSE_RENEWAL_STATUSES, ...FINAL_CERTIFICATION_RENEWAL_STATUSES]

export const isRenewalFinalized = (renewalStatus) => FINAL_RENEWAL_STATUSES.includes(renewalStatus)

export const CertificationCategory = {
  Board: 'board',
  Specialty: 'specialty',
}

export const CERTIFICATION_CATEGORY_LABELS = {
  [CertificationCategory.Board]: 'Board Certification',
  [CertificationCategory.Specialty]: 'Specialty Certification',
}

export const CERTIFICATION_STATUSES = ['Active', 'Expired']

export const ProviderStatus = {
  ClinicalDevelopmentStrategist: 'Clinical development strategist',
  CpaOnly: 'CPA only',
  CpaAndPatients: 'CPA & Patients',
  FullTime: 'Full time',
  PartTime: 'Part time',
  PerDiem: 'Per diem',
  ReducedFullTime: 'Reduced full time',
  External: 'External',
}

export const Keyboard = {
  Enter: 13,
}

export const EncounterType = {
  PEP: 'PEP',
  HepC: 'Hep C',
  HivEnrollment: 'HIV Enrollment',
  HivFollowUp: 'HIV Follow Up',
  HivInitial: 'HIV Initial',
  HivAdherence: 'HIV Adherence',
  PrepFollowUp: 'PrEP Follow Up',
  PrepInitial: 'PrEP Initial',
  PrepQuarterly: 'PrEP Quarterly',
  InjectablePrEP: 'Injectable PrEP',
  STIFollowUp: 'STI Follow Up',
  STITesting: 'STI Testing',
  Wellness: 'Wellness',
  WeightLoss: 'Weight Loss',
}

export const TreatmentType = {
  PEP: 'PEP',
  OralPrEP: 'PrEP',
  InjectablePrEP: 'Injectable PrEP',
  HIV: 'HIV',
  HepC: 'Hep C',
  STI: 'STI',
  STIPEP: 'STI-PEP',
  STITesting: 'STI Testing',
  Wellness: 'Wellness',
}

export const EncounterTypeToTreatmentType = {
  [EncounterType.PEP]: TreatmentType.PEP,
  [EncounterType.HepC]: TreatmentType.HepC,
  [EncounterType.HivEnrollment]: TreatmentType.HIV,
  [EncounterType.HivFollowUp]: TreatmentType.HIV,
  [EncounterType.HivInitial]: TreatmentType.HIV,
  [EncounterType.HivAdherence]: TreatmentType.HIV,
  [EncounterType.PrepFollowUp]: TreatmentType.OralPrEP,
  [EncounterType.PrepInitial]: TreatmentType.OralPrEP,
  [EncounterType.PrepQuarterly]: TreatmentType.OralPrEP,
  [EncounterType.InjectablePrEP]: TreatmentType.InjectablePrEP,
  [EncounterType.STIFollowUp]: TreatmentType.STI,
  [EncounterType.STITesting]: TreatmentType.STITesting,
  [EncounterType.Wellness]: TreatmentType.Wellness,
}

export const BreakGlassType = {
  Authorized: 'Authorized',
  Required: 'Required',
  RequiredWithReason: 'Required with reason',
  NotRequired: 'Not Required',
}

export const UserRole = {
  Admin: 'admin',
  Patient: 'patient',
  Provider: 'provider',
  CBO: 'cbo',
  Pharmacy: 'pharmacy',
  PharmacyManager: 'pharmacy_manager',
  MA: 'assistant',
  Support: 'support',
  Manager: 'manager',
  Manager340B: 'manager_340B',
  ClinicalAdmin: 'clinical_admin',
  ClinicalLHC: 'lhc_clinical_liaison',
  ClinicalQI: 'clinical_qi',
  Compliance: 'compliance',
}

export const userRoleToLabel = {
  [UserRole.Admin]: 'Admin',
  [UserRole.Patient]: 'Patient',
  [UserRole.Provider]: 'Provider',
  [UserRole.CBO]: 'CBO',
  [UserRole.Pharmacy]: 'Pharmacy',
  [UserRole.PharmacyManager]: 'Pharmacy Manager',
  [UserRole.MA]: 'Patient Services Representative',
  [UserRole.Support]: 'Support',
  [UserRole.Manager]: 'Manager',
  [UserRole.Manager340B]: '340B',
  [UserRole.ClinicalAdmin]: 'Clinical Admin',
  [UserRole.ClinicalLHC]: 'LHC Clinical Liaison',
  [UserRole.ClinicalQI]: 'Clinical QI & Training',
  [UserRole.Compliance]: 'Compliance',
}

export const NotesEntity = {
  Labs: 'labs',
  Users: 'users',
  Rx: 'prescriptions',
  Encounters: 'encounters',
  Appointments: 'appointments',
  Tasks: 'tasks',
}

export const UserSettingName = {
  AcceptTermsOfService: 'accept_terms_of_service',
  AcceptTelehealthConsent: 'accept_telehealth_consent',
  AcceptPrivacyPolicy: 'accept_privacy_policy',
  AllowHealthcareNotifications: 'allow_healthcare_notifications',
  AllowSharingHealthData: 'allow_sharing_health_data',
  AllowSharingHealthDataGilead: 'allow_sharing_health_data_gilead',
  AvatarPronouns: 'avatar_pronouns',
  ContactMethod: 'contact_method',
  EmailVerified: 'email_verified',
  Initials: 'initials',
  PhoneVerified: 'phone_verified',
  PreferredCommunication: 'preferred_communication',
  SelfEnrollment: 'self_enrollment',
  TimeFormat: 'time_format',
  AccessRights: 'access_rights',
  NotificationSettings: 'notification_settings',
  SendOnEnter: 'send_on_enter',
  ColorScheme: 'color_scheme',
  HidePresence: 'hide_presence',
}

export const NotificationSetting = {
  Sound: 'sound',
  GeneralDuringVisit: 'general_during_visit',
  GeneralOnTheKanban: 'general_on_the_kanban',
  OnDemandAppointmentsDuringVisit: 'on_demand_appointments_during_visit',
  AsyncMessagingAppointmentsDuringVisit: 'async_messaging_appointments_during_visit',
}

export const AppointmentPhase = {
  Scheduled: 'scheduled',
  InProgress: 'in_progress',
  Complete: 'complete',
  Missed: 'missed',
  Canceled: 'canceled',
  NotCompleted: 'not_completed',
}

export const LabPhase = {
  Ordered: 'ordered',
  KitInTransitToPatient: 'kit_in_transit_to_patient',
  KitWithPatient: 'kit_with_patient',
  KitInTransitToLab: 'kit_in_transit_to_lab',
  AwaitingDraw: 'awaiting_draw',
  AtLab: 'at_lab',
  ResultsReady: 'results_ready',
  Canceled: 'canceled',
  Failed: 'failed',
}

export const AppointmentStatus = {
  Scheduled: 'Scheduled',
  Missed: 'Missed',
  Canceled: 'Canceled',
  Waiting: 'Waiting',
  InProgress: 'In progress',
  Documenting: 'Documenting',
  Complete: 'Complete',
  Failed: 'Failed',
  Rejected: 'Rejected',
  Abandoned: 'Abandoned',
}

// Status of an On-Demand request (on_demand_log), not of its appointment.
// A regular On-Demand request stays "accepted" after the visit; only Establish requests move on to canceled/missed/completed/failed.
export const OnDemandStatus = {
  // In the queue, waiting for a provider to accept
  Pending: 'pending',
  // A provider accepted; the visit is about to start or is in progress
  Accepted: 'accepted',
  // No provider accepted within 12 minutes
  Rejected: 'rejected',
  // The patient left the waiting room, or the request was canceled before a provider accepted
  Abandoned: 'abandoned',
  // Establish only: the visit was canceled after a provider accepted
  Canceled: 'canceled',
  // Establish only: the provider marked the accepted visit as missed
  Missed: 'missed',
  // Establish only: the accepted visit was completed
  Completed: 'completed',
  // Establish only: the provider failed the accepted visit
  Failed: 'failed',
}

export const AsyncMessagingStatus = {
  Pending: 'pending',
  Accepted: 'accepted',
  Rejected: 'rejected',
  Abandoned: 'abandoned',
}

export const AsyncAppointmentWorkflowStatus = {
  Pending: 'not_started',
  InProgress: 'in_progress',
  Cancelled: 'cancelled',
  Completed: 'completed',
}

export const PreferredAppointmentType = {
  Video: 'video',
  Any: 'any',
}

export const HealthHistoryType = {
  Allergies: 'allergies',
  Conditions: 'conditions',
  Medications: 'medications',
  Surgeries: 'surgeries',
  Immunizations: 'immunizations',
  Vitals: 'vitals',
  Labs: 'lab_vitals',
}

export const VitalType = {
  Weight: 'weight',
  Height: 'height',
  BloodPressure: 'bp',
  HeartRate: 'heart_rate',
}

export const LabType = {
  RPR: 'rpr',
  Creatinine: 'creatinine',
  ViralLoad: 'viral_load',
  CD4: 'cd4',
  GFR: 'gfr',
  PHQ: 'phq',
}

export const PhqScore = {
  Min: 0,
  Max: 6,
}

export const MessageReminderCategories = {
  UploadPhotoId: 'upload_photo_id',
  AboutMe: 'about_me',
  UnfinishedAsyncMessaging: 'unfinished_async_messaging',
}

export const MessageReminderRelatedModels = {
  Assessment: 'Assessment',
  Appointment: 'Appointment',
}

export const VendorType = {
  AtHome: 'At-home Labs',
  InPerson: 'In Person',
}

export const AssessmentStatus = {
  Pending: 'pending',
  InProgress: 'in_progress',
  Expired: 'expired',
  Finished: 'finished',
  Reviewed: 'reviewed',
}

export const AsyncAssessmentStatus = {
  Pending: 'pending',
  Canceled: 'canceled',
  Completed: 'completed',
}

export const AssessmentType = {
  PEP: 'pep',
  QuarterlyLab: 'quarterly_lab',
  STI: 'sti',
  PrEPPostEncounter: 'prep_post_encounter',
  HIV: 'hiv',
  GLP1Initial: 'glp1_initial',
  GLP1FollowUp: 'glp1_follow_up',
}

export const assessmentTypeToLabel = {
  [AssessmentType.PEP]: 'PEP',
  [AssessmentType.QuarterlyLab]: 'PrEP Quarterly Lab',
  [AssessmentType.STI]: 'STI',
  [AssessmentType.PrEPPostEncounter]: 'PrEP Post-Encounter',
  [AssessmentType.HIV]: 'HIV',
  [AssessmentType.GLP1Initial]: 'GLP-1 Initial',
  [AssessmentType.GLP1FollowUp]: 'GLP-1 Follow-Up',
}

export const LabRequestStatus = {
  Pending: 'pending',
  InProgress: 'in_progress',
  Declined: 'declined',
  Finished: 'finished',
  Expired: 'expired',
  Error: 'error',
}

export const LabRequestType = {
  QuarterlyLab: 'quarterly_lab',
  PEP: 'pep',
  HIV: 'hiv',
}

export const labRequestTypeToLabel = {
  [LabRequestType.QuarterlyLab]: 'Quarterly Lab',
  [LabRequestType.PEP]: 'PEP',
  [LabRequestType.HIV]: 'HIV',
}

// Duration of the time slot in the calendar in minutes
export const TimeSlotDuration = 10

export const MedicalRecordStatus = {
  // PDF Generation statuses
  Pending: 'pending',
  InProgress: 'in_progress',
  Finished: 'finished',
  // Fax statuses
  FaxQueued: 'fax_queued',
  Faxed: 'faxed',
  FaxFailed: 'fax_failed',
}

// The number of days after which a task is highlighted as overdue
export const TaskErrorThresholdDays = 15
export const TaskWarningThresholdDays = 9

export const PossibleRedirects = {
  UploadId: 'upload-id',
  UploadInsurance: 'upload-insurance',
  UploadDocument: 'upload-document',
  UploadLab: 'upload-lab',
  UploadBp: 'upload-bp',
  UpdateAboutMe: 'update-about-me',
  BookingTreatment: 'booking-treatment',
  BookingType: 'booking-type',
  BookingAsyncMessaging: 'booking-async-messaging',
  BookingOnDemand: 'booking-on-demand',
  BookingScheduled: 'booking-scheduled',
  Task: 'task',
}

export const QuickLinkType = {
  PhotoId: 'photo_id',
  Insurance: 'insurance',
  Document: 'document',
  ManualLab: 'manual_lab',
  BloodPressure: 'bp',
}

export const quickLinkTypeToLabel = {
  [QuickLinkType.PhotoId]: 'Photo ID',
  [QuickLinkType.Insurance]: 'Insurance',
  [QuickLinkType.Document]: 'Document',
  [QuickLinkType.ManualLab]: 'Manual Lab',
  [QuickLinkType.BloodPressure]: 'BP',
}

export const OneClickIndicator = {
  Enrolled: 'ENROLLED',
  Declined: 'NOT ENROLLED',
  DeclinedWithTypo: 'NOT ENTROLLED',
  NeedToOffer: 'NEEDS ENROLL OFFERED',
}

export const InsurancePartners = {
  PrideLife: 'pride_life',
  AmericanExchange: 'american_exchange',
}

export const AvailabilityType = {
  Appointment: 'availability',
  Admin: 'admin_times',
  OutOfOffice: 'out_of_office_times',
}
export const AvailabilityStatus = {
  Approved: 'approved',
  Declined: 'declined',
  Pending: 'pending',
}
export const availabilityTypeToString = {
  [AvailabilityType.Appointment]: 'Appointment',
  [AvailabilityType.Admin]: 'Admin',
  [AvailabilityType.OutOfOffice]: 'Out of Office',
}

export const PatientCBOStatus = {
  NotEnrolled: 'not_enrolled',
  NotAllowed: 'not_allowed',
  Allowed: 'allowed',
  Waitlist: 'waitlist',
}

export const PatientCBONotAllowedReason = {
  Uninsured: 'uninsured',
  OutsideCoverageInsured: 'outside_coverage_insured',
  OutsideCoverageUninsured: 'outside_coverage_uninsured',
}

export const PaymentStatus = {
  Created: 'created',
  Error: 'error',
  Succeeded: 'succeeded',
  Canceled: 'canceled',
  HoldSuccessful: 'hold_successful',
  HoldReleased: 'hold_released',
}

export const DocumentType = {
  LabOrder: 'Lab Order',
  LabResults: 'Lab Results',
  ManualLabResults: 'Manual Lab Results',
  MedicalRecords: 'Medical Records',
  MedicalRecordsRequest: 'Medical Records Request',
  QrtlySurvey: 'Qrtly Survey',
  PaymentReceipt: 'Payment Receipt',
  HairLoss: 'Hair Loss',
  Other: 'Other',
}

export const PhotoIdValidationStatus = {
  Pending: 'pending',
  Processing: 'processing',
  Succeeded: 'succeeded',
  Failed: 'failed',
  Stale: 'stale',
}

export const PhotoIdDeletionReason = {
  ExplicitPhoto: 'Explicit Photo',
  Unreadable: 'Unreadable',
  NotAnId: 'Not an ID',
  Replaced: 'Replaced',
}

export const JourneyStep = {
  AuthLoginSuccess: 'auth_login_success',
  AuthLoginVerify: 'auth_login_verify',
  AuthVerifyCode: 'auth_verify_code',
  AppointmentTreatmentSelect: 'appointment_treatment_select',
  AppointmentTypeSelect: 'appointment_type_select',
  AppointmentAsyncMessaging: 'appointment_async_messaging',
  AppointmentAsyncMessagingCreated: 'appointment_async_messaging_created',
  AppointmentOnDemand: 'appointment_on_demand',
  AppointmentOnDemandCreated: 'appointment_on_demand_created',
  AppointmentOnDemandSwapped: 'appointment_on_demand_swapped',
  AppointmentScheduleProviders: 'appointment_schedule_providers',
  AppointmentProviderDetails: 'appointment_provider_details',
  AppointmentConfirm: 'appointment_confirm',
  AppointmentBooked: 'appointment_booked',
  AppointmentRescheduled: 'appointment_rescheduled',
  AppointmentInsuranceChecking: 'appointment_insurance_checking',
  AppointmentInsuranceRequired: 'appointment_insurance_required',
  AppointmentInsuranceProvided: 'appointment_insurance_provided',
  AppointmentInsuranceDeclined: 'appointment_insurance_declined',
  AppointmentInsuranceVerified: 'appointment_insurance_verified',
  AppointmentPayment: 'appointment_payment',
  AppointmentPaymentCompleted: 'appointment_payment_completed',
  AppointmentPaymentFailed: 'appointment_payment_failed',
  AppointmentPaymentError: 'appointment_payment_error',
  Payment: 'payment',
  PaymentCompleted: 'payment_completed',
  PaymentFailed: 'payment_failed',
  PaymentError: 'payment_error',
  PhotoId: 'photo_id',
  PhotoIdUploaded: 'photo_id_uploaded',
  AsyncVisitCompleted: 'async_visit_completed',
  AsyncVisitCanceled: 'async_visit_canceled',
  AsyncAssessmentCanceled: 'async_assessment_canceled',
  AsyncVisitEstablishScheduled: 'async_visit_establish_scheduled',
  AsyncVisitEstablishScheduleProviders: 'async_visit_establish_schedule_providers',
  AsyncVisitEstablishScheduleProvider: 'async_visit_establish_schedule_provider',
  AsyncVisitEstablishScheduleConfirm: 'async_visit_establish_schedule_confirm',
  AsyncVisitEstablishScheduleType: 'async_visit_establish_schedule_type',
  AsyncVisitEstablishOnDemand: 'async_visit_establish_on_demand',
  AsyncVisitEstablishOnDemandCreated: 'async_visit_establish_on_demand_created',
}

export const EnrollmentStep = {
  SelectFlow: 'select-flow',
  Email: 'email',
  Details: 'details',
  County: 'county',
  Medicare: 'medicare',
  CBO: 'cbo',
  Insurance: 'insurance',
  Consent: 'consent',
}

export const EnrollmentFlowType = {
  Insurance: 'insurance',
  NoInsurance: 'no-insurance',
}

export const JourneyFlowType = {
  [EnrollmentFlowType.Insurance]: 'insurance',
  [EnrollmentFlowType.NoInsurance]: 'no_insurance',
}

export const EnrollmentJourneyStep = {
  CBOSelect: 'cbo_select',
  CBOSubscribe: 'cbo_subscribe',
  CBOSubscribeConfirmed: 'cbo_subscribe_confirmed',
  CBOSubscribeDeclined: 'cbo_subscribe_declined',
  InsuranceQuestion: 'insurance_question',
  InsuranceForm: 'insurance_form',
  InsuranceWaitlist: 'insurance_waitlist',
  InsuranceWaitlistConfirmed: 'insurance_waitlist_confirmed',
  InsuranceWaitlistDeclined: 'insurance_waitlist_declined',
  Enrolled: 'enrolled',
  ExistingAccount: 'existing_account',
}

export const fieldBlurStep = (step, field) => `${step}_${field}_blur`
export const asyncVisitStep = (workflowStep) => `async_visit_${workflowStep.replace(/-/g, '_')}`
export const onDemandStep = (name) => `on_demand_${name}`
export const visitStep = (status) => `visit_${status.toLowerCase().replace(/\s+/g, '_')}`
